import { User } from 'fitify-types/src/types/user'

import { Funnel } from 'types/state'

export const isGainMuscleOffered = ({
  funnel,
  gender,
}: {
  funnel?: Funnel
  gender?: User.Profile.Gender
}) => gender === User.Profile.Gender.Male || funnel === Funnel.GYMF01

export const getFunnelFromWindowLocation = () => {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname
    return Object.values(Funnel).find((funnelValue) => {
      const funnelMatchRegex = new RegExp(`^(/[a-z]{2})?/${funnelValue}(?:/|$)`)
      return funnelMatchRegex.test(path)
    })
  }

  return undefined
}
